import axios from "axios";
import instance, { apiUrl } from "./axios.config";

const addowneruser = (payload) =>
    instance.post(`/owner/users`, payload);

const getowneruser = () =>
    instance.get(`/owner/users`);

const getownerships = () =>
    instance.get(`/owner/ships`);

const owneruserupdate = (payload) =>
    instance.put(`/owner/users`, payload);

const createowner = (payload) =>
    instance.post(`/owner/createowner`, payload);
const updateowner = (id, payload) =>
    instance.put(`/owner/updateowner/${id}`, payload);
const deleteowner = (id) =>
    instance.delete(`/owner/deleteowner/${id}`);

const updateSubscription = (payload) => instance.put("/owner/updatesubscription", payload)
const getuserSubscription = () => instance.get("/owner/usersubscription")

const ownerService = {
    createowner, deleteowner, updateowner,updateSubscription,getuserSubscription,
    getowneruser, addowneruser, getownerships, owneruserupdate
}
export default ownerService;


